"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameMicroLayout = void 0;
var react_1 = require("react");
var react_2 = require("react");
var useGameMicroLayout = function (gameData) {
    var _a = (0, react_2.useState)(false), mounted = _a[0], setMounted = _a[1];
    var script = (0, react_1.useRef)(null);
    (0, react_2.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    (0, react_2.useEffect)(function () {
        var _a, _b, _c;
        if (!mounted)
            return;
        var scriptEl = document.createElement('script');
        scriptEl.type = 'application/ld+json';
        scriptEl.text = JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name: (gameData === null || gameData === void 0 ? void 0 : gameData.title) || '',
            operatingSystem: 'Web',
            applicationCategory: 'Game',
            description: "".concat(gameData === null || gameData === void 0 ? void 0 : gameData.title, " from provider ").concat(((_a = gameData === null || gameData === void 0 ? void 0 : gameData.provider) === null || _a === void 0 ? void 0 : _a.title) || ''),
            url: ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.origin)
                ? "".concat(window.location.origin).concat(window.location.pathname)
                : '',
            author: {
                '@type': 'Organization',
                name: ((_c = gameData === null || gameData === void 0 ? void 0 : gameData.provider) === null || _c === void 0 ? void 0 : _c.title) || '',
            },
        });
        document.head.appendChild(scriptEl);
        script.current = scriptEl;
        return function () {
            var _a, _b;
            (_b = (_a = script.current) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(script.current);
            script.current = null;
        };
    }, [mounted, gameData]);
};
exports.useGameMicroLayout = useGameMicroLayout;
